import { Eye } from 'lucide-react';
import { RecordCard } from '@/components/shared/record-card';

export interface ObservationItem {
  id: number;
  enrollment: {
    user: { first_name: string; last_name: string };
    position?: { name: string } | null;
    course: { title: string };
  };
  lesson: { title: string; observation_criteria: unknown[] };
  requested_at: string;
}

interface Props {
  items: ObservationItem[];
  onConfirm: (id: number) => void;
}

/** Vista móvil (card layout) de observaciones pendientes. Oculta en `md+`. */
export function ObservationCards({ items, onConfirm }: Props) {
  return (
    <div className="space-y-3 md:hidden">
      {items.map((r) => (
        <RecordCard
          key={r.id}
          title={`${r.enrollment.user.first_name} ${r.enrollment.user.last_name}`}
          subtitle={r.enrollment.course.title}
          onClick={() => onConfirm(r.id)}
          fields={[
            { label: 'Puesto', value: r.enrollment.position?.name ?? '—' },
            { label: 'Lección', value: r.lesson.title },
            { label: 'Criterios', value: r.lesson.observation_criteria.length },
            { label: 'Solicitada', value: new Date(r.requested_at).toLocaleDateString() },
          ]}
          actions={[{ label: 'Confirmar', icon: Eye, onClick: () => onConfirm(r.id) }]}
        />
      ))}
    </div>
  );
}
